var map = {
	"./Apple2.png": 211,
	"./Ball2.png": 210,
	"./Banana2.png": 209,
	"./Bird.png": 208,
	"./Books.png": 650,
	"./Bus.png": 207,
	"./Cars.png": 648,
	"./CarsAndBicycle.png": 649,
	"./Cat2.png": 206,
	"./Circle.png": 199,
	"./Dog.png": 205,
	"./Flower2.png": 204,
	"./Grapes.png": 203,
	"./Orange.png": 200,
	"./Pear.png": 201,
	"./Pineapple.png": 202,
	"./Square.png": 198,
	"./Triangle.png": 197,
	"./apple.png": 856,
	"./baby.png": 857,
	"./bag.png": 193,
	"./ball.png": 858,
	"./banana.png": 859,
	"./bed.png": 860,
	"./bicycle.png": 861,
	"./boat.png": 862,
	"./book.png": 863,
	"./boot.png": 864,
	"./cat.png": 865,
	"./chair.png": 866,
	"./check.png": 135,
	"./cow.png": 867,
	"./crocodile.png": 868,
	"./cross.png": 869,
	"./cup.png": 870,
	"./distraction-bus.png": 214,
	"./distraction-car.png": 215,
	"./distraction-cat.png": 212,
	"./distraction-fish.png": 213,
	"./doll.png": 871,
	"./dysmate-logo-hvit-small.png": 872,
	"./ear.png": 873,
	"./elephant.png": 874,
	"./eye.png": 875,
	"./finger.png": 876,
	"./fireengine.png": 877,
	"./fish.png": 878,
	"./flower.png": 879,
	"./flowers.png": 880,
	"./foot.png": 881,
	"./giraffe.png": 196,
	"./gloves.png": 882,
	"./horse.png": 883,
	"./house.png": 884,
	"./house2.png": 192,
	"./icecream.png": 885,
	"./jeans.png": 886,
	"./key.png": 887,
	"./laptop-icon.png": 359,
	"./lion.png": 888,
	"./literate-regular-light.png": 889,
	"./logo-white.png": 63,
	"./motorcycle.png": 890,
	"./norming/rapidNaming/eple_bla-min.png": 35,
	"./norming/rapidNaming/eple_brown-min.png": 109,
	"./norming/rapidNaming/eple_grey-min.png": 891,
	"./norming/rapidNaming/eple_gronn-min.png": 113,
	"./norming/rapidNaming/eple_gul-min.png": 107,
	"./norming/rapidNaming/eple_red-min.png": 122,
	"./norming/rapidNaming/kake_blue-min.png": 123,
	"./norming/rapidNaming/kake_brown-min.png": 111,
	"./norming/rapidNaming/kake_green-min.png": 108,
	"./norming/rapidNaming/kake_grey-min.png": 892,
	"./norming/rapidNaming/kake_red-min.png": 114,
	"./norming/rapidNaming/kake_yellow-min.png": 40,
	"./norming/rapidNaming/moon_blue-min.png": 118,
	"./norming/rapidNaming/moon_brown-min.png": 36,
	"./norming/rapidNaming/moon_green-min.png": 124,
	"./norming/rapidNaming/moon_grey-min.png": 893,
	"./norming/rapidNaming/moon_red-min.png": 116,
	"./norming/rapidNaming/moon_yellow-min.png": 121,
	"./norming/rapidNaming/star_green-min.png": 120,
	"./norming/rapidNaming/stjerne_blue-min.png": 110,
	"./norming/rapidNaming/stjerne_brown-min.png": 125,
	"./norming/rapidNaming/stjerne_grey-min.png": 894,
	"./norming/rapidNaming/stjerne_gul-min.png": 41,
	"./norming/rapidNaming/stjerne_red-min.png": 34,
	"./norming/rapidNaming/sykkel-blue-min.png": 117,
	"./norming/rapidNaming/sykkel_blå-min.png": 895,
	"./norming/rapidNaming/sykkel_brown-min.png": 115,
	"./norming/rapidNaming/sykkel_grey-min.png": 896,
	"./norming/rapidNaming/sykkel_gronn-min.png": 25,
	"./norming/rapidNaming/sykkel_gul-min.png": 112,
	"./norming/rapidNaming/sykkel_red-min.png": 119,
	"./nose.png": 897,
	"./package.png": 898,
	"./pc-icon.png": 357,
	"./plane.png": 899,
	"./plowtruck.png": 900,
	"./porrige.png": 901,
	"./purse.png": 902,
	"./rabbit.png": 903,
	"./rapidNaming/bamse.png": 904,
	"./rapidNaming/blabamse.png": 45,
	"./rapidNaming/blaeple.png": 47,
	"./rapidNaming/blagenser.png": 46,
	"./rapidNaming/blasykkel.png": 48,
	"./rapidNaming/blatommel.png": 31,
	"./rapidNaming/elefant.png": 905,
	"./rapidNaming/eple.png": 906,
	"./rapidNaming/genser.png": 907,
	"./rapidNaming/grabamse.png": 24,
	"./rapidNaming/graeple.png": 28,
	"./rapidNaming/gragenser.png": 27,
	"./rapidNaming/grasykkel.png": 30,
	"./rapidNaming/gratommel.png": 29,
	"./rapidNaming/gronnbamse.png": 57,
	"./rapidNaming/gronneple.png": 59,
	"./rapidNaming/gronngenser.png": 58,
	"./rapidNaming/gronnsykkel.png": 61,
	"./rapidNaming/gronntommel.png": 60,
	"./rapidNaming/oransjebamse.png": 49,
	"./rapidNaming/oransjeeple.png": 32,
	"./rapidNaming/oransjegenser.png": 50,
	"./rapidNaming/oransjesykkel.png": 52,
	"./rapidNaming/oransjetommel.png": 51,
	"./rapidNaming/paraply.png": 908,
	"./rapidNaming/prinsesse.png": 909,
	"./rapidNaming/rodbamse.png": 53,
	"./rapidNaming/rodeple.png": 54,
	"./rapidNaming/rodgenser.png": 33,
	"./rapidNaming/rodsykkel.png": 56,
	"./rapidNaming/rodtommel.png": 55,
	"./rapidNaming/stoevsuger.png": 910,
	"./rapidNaming/sykkel.png": 911,
	"./rapidNaming/tannboerste.png": 912,
	"./rapidNaming/tommel.png": 913,
	"./reflex.png": 914,
	"./saft.png": 915,
	"./server-icon.png": 358,
	"./sheep.png": 195,
	"./shoe.png": 916,
	"./ski.png": 917,
	"./spoon.png": 918,
	"./sun.png": 919,
	"./sweater.png": 920,
	"./teddy.png": 921,
	"./telephone.png": 922,
	"./tractor.png": 923,
	"./whale.png": 194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 855;